// Печать «Моих документов»: картинки — по две на лист A4 (разворот паспорта + прописка), PDF — через скрытый iframe.
const fileUrl = d => `/api/my-docs/${d.id}/file`;

function printPdf(d) {
  const f = document.createElement('iframe');
  f.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
  f.src = fileUrl(d);
  f.onload = () => {
    try { f.contentWindow.focus(); f.contentWindow.print(); }
    catch { window.open(fileUrl(d), '_blank'); }
    setTimeout(() => f.remove(), 60000);
  };
  document.body.appendChild(f);
}

function printImages(docs) {
  const w = window.open('', '_blank');
  if (!w) { alert('Браузер заблокировал окно печати — разрешите всплывающие окна для CRM'); return; }
  const imgs = docs.map(d => `<img src="${fileUrl(d)}" alt="">`).join('');
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Печать</title><style>
    @page { size: A4; margin: 10mm; }
    body { margin: 0; text-align: center; }
    img { display: block; margin: 0 auto 6mm; max-width: 100%; max-height: 135mm; object-fit: contain; page-break-inside: avoid; }
    img:nth-of-type(2n) { page-break-after: always; }
  </style></head><body>${imgs}<script>
    const all = [...document.images]; let left = all.length;
    const go = () => { if (--left <= 0) { window.focus(); window.print(); } };
    all.forEach(i => i.complete ? go() : (i.onload = i.onerror = go));
    window.onafterprint = () => window.close();
  </script></body></html>`);
  w.document.close();
}

export function printDocs(docs) {
  const list = (docs || []).filter(Boolean);
  if (!list.length) return;
  const images = list.filter(d => /^image\//.test(d.mimetype));
  if (images.length) printImages(images);
  list.filter(d => d.mimetype === 'application/pdf').forEach(printPdf);
}
